/** @jsxImportSource @emotion/react */
import { Text } from "basis";
import { SvgInline } from "components/SvgInline/SvgInline";

export const DisabledByFeatureFlag = () => (
  <div
    css={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      height: "100vh",
    }}
  >
    <SvgInline name="icon-security-lock" size="128" />
    <Text>
      Sorry, this feature is currently unavailable. Please try again later.
    </Text>
  </div>
);
